import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alert__header" }
const _hoisted_2 = { class: "alert__body" }
const _hoisted_3 = { class: "alert__footer" }

import { computed } from 'vue';

import SmIcon from '@/components/ui/SmIcon/SmIcon.vue';
import SmTextButton from '@/components/ui/buttons/SmTextButton/SmTextButton.vue';

import { IAlertProps } from '@/@types/components/ui/alerts';

import '@/components/ui/SmAlert/style.scss';

// [START] Props

export default /*#__PURE__*/_defineComponent({
  __name: 'SmAlert',
  props: {
    title: { default: '' },
    text: { default: '' },
    type: { default: 'success' },
    showIcon: { type: Boolean, default: true },
    footerButtonText: { default: '' }
  },
  emits: ['footer-click'],
  setup(__props: any, { emit: emits }) {

const props = __props;


// [END] Props

// [START] Emits

// [END] Emits

// [START] Computed properties
const classListMap = {
  success: 'alert--success',
  error: 'alert--error',
  warning: 'alert--warning',
  info: 'alert--info',
};

const classList = computed((): string => {
  return classListMap[props.type] || '';
});

const iconNameMap = {
  success: 'CheckCircle',
  error: 'AlertCircle',
  warning: 'AlertTriangle',
  info: 'AlertCircle',
};

const iconName = computed((): string => {
  return iconNameMap[props.type] || 'AlertCircle';
});
// [END] Computed properties

// [START] Methods
const handleClickFooterButton = (): void => {
  emits('footer-click');
};
// [END] Methods

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "alert",
    class: _normalizeClass(["alert", classList.value])
  }, [
    _createElementVNode("h4", _hoisted_1, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        (props.showIcon)
          ? (_openBlock(), _createBlock(SmIcon, {
              key: 0,
              name: iconName.value,
              class: "alert__icon"
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(props.title), 1)
      ])
    ]),
    _createElementVNode("p", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(props.text), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "footer", {}, () => [
        (props.footerButtonText)
          ? (_openBlock(), _createBlock(SmTextButton, {
              key: 0,
              type: props.type,
              onClick: handleClickFooterButton
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.footerButtonText), 1)
              ]),
              _: 1
            }, 8, ["type"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})